/// <amd-module name="Build/Admin/Common/Sources/AgentDefinitionSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { AgentDefinition } from "PoolProvider/Shared/Contracts/PoolProviderShared";

import { DataProviders } from "Build/Admin/Common/Constants";

export class AgentDefinitionSource {
    private _agentDefinitions: AgentDefinition[] | undefined;

    constructor(pageContext: IVssPageContext) {
        const contributionService: IVssContributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        this._agentDefinitions = contributionService.getData<AgentDefinition[]>(DataProviders.AgentDefinitions);
    }

    public getCachedAgentDefinitions(): AgentDefinition[] {
        if (this._agentDefinitions) {
            return this._agentDefinitions;
        }
        else {
            return [];
        }
    }
}
